export default __webpack_public_path__ + "static/media/Ficha_frijol.f7649671.png";